import React, { ReactNode } from "react";

import { useGeneralContext, useTranslation } from "utils";

import { Flex, Icon, TooltipWrapper, Typography } from "components";

type CollapsibleImpactPanelProps = {
  className?: string;
  children: ReactNode;
};

export const ImpactPanelCollapseToggle = () => {
  const { t } = useTranslation("fieldTimeline");
  const { impactPanelCollapsed, setImpactPanelCollapsed } = useGeneralContext();

  const label = impactPanelCollapsed ? t("impactPanel.expandTooltip") : t("impactPanel.collapseTooltip");

  return (
    <TooltipWrapper tooltip={{ title: label, placement: "left" }} variant="compact">
      <button
        type="button"
        className={`impact-panel-collapse-toggle${impactPanelCollapsed ? " collapsed" : ""}`}
        data-testid="impact-panel-collapse-toggle"
        aria-label={label}
        aria-expanded={!impactPanelCollapsed}
        onClick={() => setImpactPanelCollapsed((prev) => !prev)}
      >
        <Icon iconName="tabler/chevrons-right" size="m-light" />
      </button>
    </TooltipWrapper>
  );
};
export const CollapsibleImpactPanel = ({ className = "", children }: CollapsibleImpactPanelProps) => {
  const { t } = useTranslation("fieldTimeline");
  const { impactPanelCollapsed } = useGeneralContext();

  return (
    <Flex vertical className={`all-field-view sidebar impact-panel-collapsible${impactPanelCollapsed ? " collapsed" : ""} ${className}`.trim()}>
      {impactPanelCollapsed ? (
        <>
          <Flex justify="center" className="impact-panel-collapse-strip-header">
            <ImpactPanelCollapseToggle />
          </Flex>
          <Typography variant="h4" className="impact-panel-collapse-title">
            {t("impactPanel.collapsedTitle")}
          </Typography>
        </>
      ) : (
        <div className="impact-panel-collapsible-content">{children}</div>
      )}
    </Flex>
  );
};
